module.exports = __webpack_public_path__ + "static/media/bestfriends.14535e76.jpg";